import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ion-margin-top" }
const _hoisted_2 = { class: "ion-margin-top" }
const _hoisted_3 = { class: "ion-padding-horizontal" }
const _hoisted_4 = { class: "ion-margin-top" }
const _hoisted_5 = { class: "ion-padding-horizontal" }
const _hoisted_6 = { class: "ion-margin-top" }
const _hoisted_7 = { class: "ion-margin ion-padding-vertical" }
const _hoisted_8 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_checkbox = _resolveComponent("ion-checkbox")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _cache[1] || (_cache[1] = _createElementVNode("h3", {
                slot: "start",
                class: "ion-no-margin ion-margin-start"
              }, " Filter ", -1)),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    "icon-only": "",
                    onClick: _ctx.closeModal
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, { icon: _ctx.closeOutline }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (!_ctx._isEmpty(_ctx.filterMetadata))
        ? (_openBlock(), _createBlock(_component_ion_content, {
            key: 0,
            class: "ion-no-padding"
          }, {
            default: _withCtx(() => [
              _cache[10] || (_cache[10] = _createElementVNode("h3", { class: "ion-padding-start ion-margin-bottom" }, " Year of production ", -1)),
              _createVNode(_component_ion_item, { class: "ion-no-padding" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_grid, { class: "ion-no-padding ion-padding-start" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_row, { class: "ion-padding-bottom" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_col, {
                            class: "ion-padding-end ion-justify-content-between ion-align-items-center",
                            onClick: _ctx.openYearSinceSelectionModal
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _cache[2] || (_cache[2] = _createTextVNode(" From ", -1)),
                                    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.filter.since || 'Any'), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createVNode(_component_ion_icon, { icon: _ctx.caretDownOutline }, null, 8, ["icon"])
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createVNode(_component_ion_col, {
                            class: "ion-padding-start ion-justify-content-between ion-align-items-center",
                            onClick: _ctx.openYearTillSelectionModal
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _cache[3] || (_cache[3] = _createTextVNode(" To ", -1)),
                                    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.filter.till || 'Now'), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createVNode(_component_ion_icon, { icon: _ctx.caretDownOutline }, null, 8, ["icon"])
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_item, {
                class: "ion-no-padding",
                button: "",
                "detail-icon": _ctx.caretForwardOutline,
                onClick: _ctx.openEventSelectionModal
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_ion_label, { class: "ion-padding-vertical" }, {
                      default: _withCtx(() => [
                        _cache[4] || (_cache[4] = _createTextVNode(" Purpose of issue ", -1)),
                        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.filter.event?.title || 'All'), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 8, ["detail-icon", "onClick"]),
              _createVNode(_component_ion_item, {
                class: "ion-no-padding",
                button: "",
                "detail-icon": _ctx.caretForwardOutline,
                onClick: _ctx.openCountrySelectionModal
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_ion_label, { class: "ion-padding-vertical" }, {
                      default: _withCtx(() => [
                        _cache[5] || (_cache[5] = _createTextVNode(" Country ", -1)),
                        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.filter.country?.title || 'All'), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 8, ["detail-icon", "onClick"]),
              _createVNode(_component_ion_item, { class: "ion-no-padding" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, { class: "ion-padding-start ion-padding-vertical ion-no-margin" }, {
                    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                      _createTextVNode("Official ", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_ion_checkbox, {
                    checked: _ctx.filter.official,
                    onIonChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.filter.official = $event.detail.checked))
                  }, null, 8, ["checked"])
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_ion_button, {
                  class: "--default",
                  onClick: _ctx.closeModal
                }, {
                  default: _withCtx(() => [
                    _cache[7] || (_cache[7] = _createTextVNode(" Show me ", -1)),
                    (_ctx.totalPinsByFilter)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, "  (" + _toDisplayString(_ctx.totalPinsByFilter) + ")  ", 1))
                      : _createCommentVNode("", true),
                    _cache[8] || (_cache[8] = _createTextVNode(" pins ", -1))
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_ion_button, {
                  fill: "clear",
                  expand: "full",
                  size: "small",
                  onClick: _ctx.onRemoveAllFilters
                }, {
                  default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                    _createTextVNode("Remove all filters ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}